module.exports = __webpack_public_path__ + "static/media/splitscreen.ca855696.avif";